import { Typography, Chip } from '@mui/material';
import styled from 'styled-components';

import Card from '../../../components/Card';
import Slider from '../../../components/Slider';
import colors from '../../../styles/colors';

const ImageSliderContainer = styled(Card)`
  position: relative;
  width: 100%;
  max-width: 500px;
  aspect-ratio: 1.5;
  max-height: 100%;
  padding: 0;
  box-sizing: border-box;
  border-radius: 5px;
  margin: 4px 8px;
`;

const ImageCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledSlider = styled(Slider)`
  .slick-dots {
    bottom: 0;
    padding: 15px 0;
    li button:before {
      font-size: 12px;
    }
  }
  .slick-slide > div {
    padding: 0;
  }
  .slick-slider {
    height: 100%;
  }
`;

const StyledImage = styled.img`
  max-width: 100%;
  height: ${({ $height }) => ($height ? `${$height}px` : '100%')};
  width: 100%;
  object-fit: contain;
`;

const DateText = styled(Typography)`
  text-align: center;
  font-size: 12px;
`;

const Title = styled.div`
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  border-bottom: 1px solid ${colors.shades.gamma3};
  margin-bottom: 5px;
`;

const SpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  aspect-ratio: 1.5;
  background-color: ${colors.shades.gamma3};
`;

const StyledChip = styled(Chip)`
  position: absolute;
  bottom: 20px;
  background-color: ${colors.addAlpha(colors.base.beta, 0.5)};
  color: ${colors.base.alpha};
  font-size: 10px;
  font-weight: 500;
  height: 24px;
  margin-left: 10px;
`;

/*
  Sits over the slider's top-right corner, anchored to `ImageSliderContainer` — the only positioned
  ancestor here. `ImageCard` deliberately is not one: an overlay inside the slides renders once per
  photo, all at the same spot.

  Opaque rather than a translucent scrim, because it lands on progress photos of every exposure and a
  50%-black circle disappears against a dark one. `z-index` clears slick's own arrows.
*/
const SlideActionButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid ${colors.shades.gamma3};
  border-radius: 50%;
  background-color: ${colors.base.alpha};
  color: ${colors.shades.dark1};
  line-height: 1;
  cursor: pointer;
  box-shadow: 0 1px 4px ${colors.addAlpha(colors.base.beta, 0.3)};

  &:hover {
    background-color: ${colors.base.gamma};
  }
`;

const BlockedSlideAction = styled(SlideActionButton)`
  border-color: ${colors.shades.danger4};
  color: ${colors.shades.danger3};
  cursor: not-allowed;

  &:hover {
    background-color: ${colors.shades.danger2};
  }
`;

export {
  ImageSliderContainer,
  ImageCard,
  SpinnerContainer,
  StyledSlider,
  StyledImage,
  DateText,
  Title,
  StyledChip,
  SlideActionButton,
  BlockedSlideAction,
};
